import Mustache from 'mustache';

const campaignSearch = {
  _searchResultsList: null,
  _searchResultsTemplate: null,
  _loadMoreContainer: null,
  _loadMoreCount: null,
  _noCampaignsFound: null,
  _searchFilters: {},
  _isUpdateUrl: false,
  _language: typeof window.stage_language !== 'undefined' ? window.stage_language : window.location.href.split('/')[3],

  init: function() {
    const self = this;
    const campaignSearchForm = document.getElementById('campaign-search-form');

    if (campaignSearchForm) {
      self._searchResultsList = document.getElementById('campaign-search-results-list');
      self._searchResultsTemplate = document.getElementById('campaign-search-results-template');
      self._loadMoreContainer = document.getElementById('load-more-campaigns-container');
      self._loadMoreCount = document.getElementById('load-more-campaigns-count');
      self._noCampaignsFound = document.getElementById('no-campaigns-found');
      self._isUpdateUrl = 'updateUrl' in campaignSearchForm.dataset;

      const languageLinks = {
        fi: {
          elements: document.getElementsByClassName('lang_fi'),
          pageName: 'kampanjat'
        },
        sv: {
          elements: document.getElementsByClassName('lang_sv'),
          pageName: 'kampanjer'
        }
      };

      // If ad uuids are provided, add them to search filters
      const campaignUuidsInput = document.getElementById('campaign-uuids');

      if (campaignUuidsInput && campaignUuidsInput.value) {
        self._updateSearchFilters(campaignUuidsInput.name || 'uuid', campaignUuidsInput.value);
      }

      // Listen to checkboxes
      const checkboxes = campaignSearchForm.querySelectorAll('input[type="checkbox"]');

      for (const checkbox of checkboxes) {
        // Get initial values, in case checkboxes have been pre-checked through get params
        self._updateSearchFilters(
          checkbox.name,
          Array.from(checkboxes).filter(checkbox => checkbox.checked).map(checkbox => checkbox.value) // Get array of checkbox values of checked checkboxes
        );

        checkbox.addEventListener('change', function(event) {
          self._updateSearchFilters(
            event.target.name,
            Array.from(checkboxes).filter(checkbox => checkbox.checked).map(checkbox => checkbox.value)
          );

          if (self._isUpdateUrl) {
            const pageParams = self._getPageParamsString();

            self._updateUrl(pageParams);
            self._updateLanguageLinks(languageLinks, pageParams);
          }

          self._executeSearch();
        });
      }

      // Listen to multiselects
      const multiselectKeys = window.multiselects ? Object.keys(window.multiselects) : [];

      for (const key of multiselectKeys) {
        if (window.multiselects[key].selectDetails.form === campaignSearchForm) { // Check if multiselect actually belongs to campaign search form
          // Get initial values, in case options have been pre-selected through get params
          self._updateSearchFilters(
            window.multiselects[key].selectDetails.name,
            window.multiselects[key].getValue()
          );

          Array.from(window.multiselects[key].multiselectList.children).forEach(listItem => {
            listItem.style.order = Number(listItem.dataset.index) || 0;
          });

          window.multiselects[key].addCallback({
            onValueChange: function(multiselectData) {
              self._updateSearchFilters(
                multiselectData.selectDetails.name,
                multiselectData.getValue()
              );

              if (self._isUpdateUrl) {
                const pageParams = self._getPageParamsString();

                self._updateUrl(pageParams);
                self._updateLanguageLinks(languageLinks, pageParams);
              }

              self._executeSearch(false, multiselectData.element.id);
            }
          });
        }
      }

      // Listen to load more button
      const loadMoreButton = document.getElementById('load-more-campaigns');

      loadMoreButton.addEventListener('click', function() {
        self._executeSearch(true);
      });
    }
  },

  _updateSearchFilters: function(name, value) {
    if (value && value.length) {
      this._searchFilters[name] = value;
    }
    else {
      delete this._searchFilters[name];
    }
  },

  _getPageParamsString: function() {
    const pageParams = [
      this._searchFilters.makes || (this._searchFilters.category || this._searchFilters.outlets ? 'kaikki-merkit' : false), // If make is false, but category and/or outlet is not, add param 'kaikki-merkit'
      this._searchFilters.category || (this._searchFilters.outlets ? 'kaikki-kategoriat' : false), // If category is false, but outlet is not, add param 'kaikki-kategoriat'
      this._searchFilters.outlets || false
    ].filter(Boolean);

    return pageParams.length ? pageParams.join('/') + '/' : '';
  },

  _updateUrl: function(pageParams) {
    const pageName = this._language === 'sv' ? 'kampanjer' : 'kampanjat',
      pageNameEndIndex = window.location.href.indexOf(pageName) + pageName.length,
      pageUrl = window.location.href.substring(0, pageNameEndIndex) + '/';

    window.history.pushState(null, null, pageUrl + pageParams);
  },

  _updateLanguageLinks: function(languageLinks, pageParams) {
    Object.keys(languageLinks).forEach(function(language) {
      if (languageLinks[language].elements && languageLinks[language].elements.length) {
        const languageUrl = '/' + language + '/' + languageLinks[language].pageName + '/' + pageParams;
        languageLinks[language].elements[0].href = languageUrl;
      }
    });
  },

  _executeSearch: function(loadAll = false, inputId = '') {
    const self = this;

    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/stage-ajax/get-token?stage-language=' + self._language);
      xhr.onload = resolve;
      xhr.onerror = reject;
      xhr.send();
    })
      .then(function(e) {
        return JSON.parse(e.target.response);
      })
      .then(function(data) {
        let filterParams = '';

        Object.keys(self._searchFilters).forEach(function(filter) {
          filterParams += `&${encodeURIComponent(filter)}=${encodeURIComponent(self._searchFilters[filter])}`
        });

        new Promise(function (resolve, reject) {
          const xhr = new XMLHttpRequest(),
            url = '/stage-ajax/campaign-search?stage-language='
          + self._language
          + filterParams
          + (loadAll ? '&load_all=true' : '')
          + '&token=' + data.token;

          xhr.open('GET', url);
          xhr.onload = resolve;
          xhr.onerror = reject;
          xhr.send();
        })
          .then(function(e) {
            return JSON.parse(e.target.response);
          })
          .then(function(searchResults) {
            self._displaySearchResults(searchResults, loadAll, inputId);
          });
      });
  },

  _displaySearchResults: function(searchResults, loadAll, inputId) {
    if (searchResults && searchResults.campaigns) {
      if (loadAll) {
        this._searchResultsList.innerHTML += Mustache.render(this._searchResultsTemplate.innerHTML, {
          campaigns: searchResults.campaigns
        });

        this._loadMoreContainer.hidden = true;
      }
      else {
        this._searchResultsList.innerHTML = Mustache.render(this._searchResultsTemplate.innerHTML, {
          campaigns: searchResults.campaigns
        });

        if (searchResults.campaigns.length) {
          this._noCampaignsFound.hidden = true;

          if (searchResults.restCount) {
            this._loadMoreCount.innerHTML = searchResults.restCount;
            this._loadMoreContainer.hidden = false;
          }
          else {
            this._loadMoreContainer.hidden = true;
          }

          if (inputId !== 'campaign-search-make' || !window.multiselects['campaign-search-make'].getValue().length) { // If triggering input is other than 'campaign-search-make', or if all options of it were just unselected
            this._updateFilterOptions(window.multiselects['campaign-search-make'], searchResults.uniqueMakes); // Update make options
          }

          if (inputId !== 'campaign-search-outlet' || !window.multiselects['campaign-search-outlet'].getValue().length) { // If triggering input is other than 'campaign-search-outlet', or if all options of it were just unselected
            this._updateFilterOptions(window.multiselects['campaign-search-outlet'], searchResults.uniqueOutlets); // Update outlet options
          }
        }
        else {
          this._noCampaignsFound.hidden = false;
          this._loadMoreContainer.hidden = true;
        }
      }
    }
  },

  _updateFilterOptions(multiselect, matchingOptions) {
    // Get multiselect option values that would not yield any search results
    const nonMatchingValues = multiselect.options.map(multiselectOption => multiselectOption.value).filter(optionValue => {
      return !matchingOptions.some(matchingOption => matchingOption.value === optionValue);
    });

    multiselect.removeOptions(nonMatchingValues);

    // Get options that would yield search results, but do not exist in the multiselect
    const matchingOptionsToAdd = matchingOptions.filter(matchingOption => {
      return !multiselect.options.some(multiselectOption => multiselectOption.value === matchingOption.value);
    });

    // Add such options to multiselect
    multiselect.addOptions(matchingOptionsToAdd);

    if (multiselect.options.length) {
      multiselect.enableMultiselect();

      // Update list items' order to keep them sorted, after removing and adding options
      Array.from(multiselect.multiselectList.children).forEach(listItem => {
        listItem.style.order = Number(listItem.dataset.index) || 0;
      });
    }
    else {
      multiselect.disableMultiselect(); // If multiselect has no options, disable it
    }
  }
};

export default campaignSearch;
